import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { ToggleButton } from '../../../index';
import { GuestSelectorComponentProps } from '../sharedTypes';

export const ToggleExtra: FC<GuestSelectorComponentProps> = ({
  input: { value, onChange },
  isDisabled,
}) => {
  const { t } = useTranslations();

  return (
    <ToggleButton
      onClick={() => onChange(!value)}
      isSelected={!!value}
      selectedText={t('spa.extrasSelectedCTA')}
      type="button"
      isDisabled={isDisabled}
      inverted
    >
      {t('spa.extrasSelectCTA')}
    </ToggleButton>
  );
};
